import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { FormatSizeUnitsModule } from '@y42/core/format-size-units';
import { NgxFileDropModule } from 'ngx-file-drop';
import { FileUploadDialogComponent } from './file-upload-dialog.component';

@NgModule({
  imports: [CommonModule, NgxFileDropModule, FormatSizeUnitsModule, MatButtonModule],
  declarations: [FileUploadDialogComponent],
  exports: [FileUploadDialogComponent],
})
export class FileUploadDialogModule {}
